export enum ProductSelectDisplayMode {
  AddTechnicalCondition,
  AddOnlyProduct
}